import { render, staticRenderFns } from "./section-results.vue?vue&type=template&id=38c64e80&"
import script from "./section-results.vue?vue&type=script&lang=js&"
export * from "./section-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports